import { ChangeDetectionStrategy, Component, Inject, OnInit } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { AuthService } from '@ortho-next/auth-core';
import { SseService } from '@ortho-next/sse';
import { firstValueFrom } from 'rxjs';
import { APP_CONFIG, AppConfig, LanguageService, MonitoringService, ToastService } from './core';
import { CookieBannerService, TitleService } from './services';


/**
* Root application component
*/
@Component({
	selector: 'app-root',
	templateUrl: './app.component.html',
	imports: [
		RouterOutlet
	],
	changeDetection: ChangeDetectionStrategy.Eager
})

export class AppComponent implements OnInit {

	constructor(
		private readonly sse: SseService,
		private readonly titleSrv: TitleService,
		private readonly toastSrv: ToastService,
		private readonly langSrv: LanguageService,
		private readonly authService: AuthService,
		private readonly cookieBannerSr: CookieBannerService,
		private readonly monitoringService: MonitoringService,
		@Inject(APP_CONFIG) private readonly config: AppConfig
	) {
		authService.isDoneLoading$.subscribe(() => {
			if (authService.hasValidToken()) {
				sse.connection(config.sseAPI, () => firstValueFrom(authService.getAccessToken()));

				const userName = authService.userName;
				if (userName) {
					monitoringService.setAuthenticatedUserId(userName);
				}
			}
		});
		authService.onLogout$.subscribe(() => monitoringService.clearAuthenticatedUserId());
	}

	ngOnInit(): void {
		this.titleSrv.init();
		if (this.authService.hasChangePassword) {
			this.toastSrv.showSuccess(this.langSrv.labels().APP_COMPONENT_CHANGE_PASSWORD_SUCCESS);
		}

		this.cookieBannerSr.openBanner();

		(globalThis as any).noCircleDetection = false;
	}

}